var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_12622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1L16.7942 5.5H1.20577L9 1Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15L9 6",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 16.5,
    x2: 15.5,
    y2: 5.5,
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 16L2 6",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    width: 16,
    height: 2,
    fill: "white",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_12622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.31f6ac1f9559080e13ae0c6e6745c3df.svg";
export { ForwardRef as ReactComponent };